import {forward, merge} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {loadProfileFx, loginFx, loginWithCertFx} from 'models/auth';

import {createUserFx} from '../staff/table';

import {
    createParticipantFx,
    data$,
    editParticipantData$,
    firs$,
    FIRSGate,
    getCredentialsFIRSFx,
    loadParticipantsDataFx,
    loadProfileCommonDataFx,
    loadProfileCountiesFx,
    onChangeParticipantIdForRemoveConfirmation,
    onSetEditParticipant,
    participantIdForRemoveConfirmation$,
    ParticipantsGate,
    participantsList$,
    profileCountries$,
    removeParticipantFx,
    setCredentialsFIRSFx,
    updateParticipantFx,
} from './index';

data$.on(loadProfileCommonDataFx.done, (_, {result}) => result);
profileCountries$.on(loadProfileCountiesFx.done, (_, {result}) => result);
editParticipantData$.on(onSetEditParticipant, (_, payload) => payload);
participantIdForRemoveConfirmation$
    .on(onChangeParticipantIdForRemoveConfirmation, (_, payload) => payload)
    .reset(ParticipantsGate.close);

firs$.on(getCredentialsFIRSFx.done, (_, {result}) => result).reset(ParticipantsGate.close);

participantsList$
    .on(loadParticipantsDataFx.done, (_, {result}) => result)
    .reset(ParticipantsGate.close);

forward({
    from: merge([ParticipantsGate.open, removeParticipantFx.done]),
    to: loadParticipantsDataFx,
});

forward({
    from: merge([loginFx.done, loadProfileFx.done, loginWithCertFx.done, createUserFx.done]),
    to: [loadProfileCommonDataFx, loadProfileCountiesFx],
});

forward({
    from: FIRSGate.open,
    to: getCredentialsFIRSFx,
});

forward({
    from: setCredentialsFIRSFx.done,
    to: getCredentialsFIRSFx,
});

createParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.success')),
);
updateParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.update')),
);
removeParticipantFx.doneData.watch(() =>
    toast.success(i18next.t('pages.profile.participant.messages.removed')),
);

[
    loadProfileCommonDataFx,
    loadProfileCountiesFx,
    loadParticipantsDataFx,
    createParticipantFx,
    updateParticipantFx,
    removeParticipantFx,
].forEach((fx) => fx.failData.watch((err) => showRestError(err as RestError)));
